import React from 'react';
import { FormGroup, FormField } from 'semantic-ui-react';

import { QUESTIONS, TRIAGE_QUESTION_ID } from '../fixtures';

import type { SharedProps } from './shared';

/**
 * Question 53: Did the member receive the delivery?
 * If Yes → ReceivedPathSection (54–62)
 * If No → NotReceivedPathSection (65–66b)
 */
export const MemberReceivedSection: React.FC<SharedProps> = ({ handleQuestion, getAnswer }) => {
  const q03 = getAnswer(TRIAGE_QUESTION_ID.MEMBER_RECEIVED);

  return (
    <FormGroup grouped>
      <label>{QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].questionText}</label>
      <FormField
        label={QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].options[0]}
        control="input"
        type="radio"
        name="memberReceived"
        checked={q03 === QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].options[0]}
        onChange={() => handleQuestion(TRIAGE_QUESTION_ID.MEMBER_RECEIVED, QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].options[0])}
      />
      <FormField
        label={QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].options[1]}
        control="input"
        type="radio"
        name="memberReceived"
        checked={q03 === QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].options[1]}
        onChange={() => handleQuestion(TRIAGE_QUESTION_ID.MEMBER_RECEIVED, QUESTIONS[TRIAGE_QUESTION_ID.MEMBER_RECEIVED].options[1])}
      />
    </FormGroup>
  );
};
